import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SearchSubProject from '../../components/forms/searchSubProject/SearchSubProject'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadRegisterControl } from '../../redux/actions/subProjectReport'

export default function ProjectControlReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})

  useEffect(() => {
    buttonDisabled()
  }, [])

  const buttonDisabled = () => {
    const disValue = {
      buttonText: formSchema.buttonText.disabled,
    }
    setDisableValue(disValue)
  }

  const onSubmit = (data) => {
    handleCallReportSubmitPdf(data.mainProjectOption)
  }

  const onDownload = async (fileObj) => {
    if (fileObj) {
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.fileName || `ทะเบียนควบคุมโครงการ`)
      document.body.appendChild(link)
      link.click()
    }
  }

  const handleCheangMainProject = (data) => {
    const disValue = {
      buttonText: false,
    }
    setDisableValue(disValue)
  }

  const handleCancel = () => {
    buttonDisabled()
    for (const key in getValues()) {
      setValue(key, null)
    }
  }

  const handleCallReportSubmitPdf = async (mainProjectId) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)

    try {
      const response = await downloadRegisterControl(mainProjectId)

      if (response) {
        onDownload(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error(e)
      setIsPdfError(true)
    }

    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <SearchSubProject
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onChangeMainProject={handleCheangMainProject}
            disabledValue={disabledValue}
          />
        )}

        <hr />
        {isPdfError && (
          <>
            <Message showIcon type="error" description={'ไม่สามารถโหลดไฟล์ได้'} />
            <br />
          </>
        )}

        <ButtonPanelWidget
          isDisabled={disabledValue.buttonText}
          isEdit={isEdit}
          isError={isError}
          buttonText={formSchema.buttonText}
          onPrint={handleSubmit(onSubmit)}
          onCancel={(el) => {
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>

      <br />
    </>
  )
}
